const BallButton = ({ ballColor, children="전체", onClick, isActive, ...rest }) => {

  return (
    <button
      className={`
        flex gap-1 items-center text-sm cursor-pointer
        ${isActive ? "" : "line-through opacity-50 hover:opacity-100 hover:no-underline"}
      `}
      onClick={onClick}
      {...rest}
    >
      <span className="w-2 h-2 rounded-full" style={{backgroundColor: ballColor }}></span>
      {children}
    </button>
  )
}

export default BallButton